import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('userName', userName);

function userName() {
  return function (user, defaultValue?) {
    const firstName = _.get(user, 'firstName');
    const lastName = _.get(user, 'lastName');
    const fullName = _.get(user, 'fullName');
    const businessName = _.get(user, 'businessName');
    return !!fullName ? fullName :
      (firstName && lastName ? `${firstName} ${lastName}` : (businessName || defaultValue || '----'));
  }
}
